import React from 'react';
export function PricingSection() {
  return <section id="precios" className="py-20 w-full" style={{
    backgroundColor: '#f5f5f5'
  }} aria-labelledby="precios-title" data-id="element-146">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-147">
        {/* Header */}
        <div className="text-center mb-12" data-id="element-148">
          <span className="inline-block text-gold font-bold uppercase tracking-widest text-sm mb-3" data-id="element-149">
            Elegí tu Pack
          </span>
          <h2 id="precios-title" className="font-heading text-4xl sm:text-5xl font-bold text-navy-deep mb-4" data-id="element-150">
            Acceso Inmediato a Todo
          </h2>
          <p className="text-gray-500 text-lg" data-id="element-151">
            Acceso inmediato a todos los recursos
          </p>
        </div>

        {/* Pricing Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-start" data-id="element-152">
          {/* Card 1: Oferta Limitada */}
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden flex flex-col" style={{
          border: '2px solid #c9a84c'
        }} data-id="element-153">
            {/* Top Badge */}
            <div className="bg-gold text-navy-deep text-center font-bold uppercase tracking-widest text-sm py-3" data-id="element-154">
              OFERTA LIMITADA
            </div>

            <div className="p-8 flex flex-col flex-1" data-id="element-155">
              {/* Product Name */}
              <h3 className="font-heading text-2xl font-bold text-navy-deep mb-2" data-id="element-156">
                Mega Pack Catequesis Lista
              </h3>
              <p className="text-gray-500 text-sm mb-6" data-id="element-157">
                Todo lo que necesitás para dar clases increíbles de catequesis
              </p>

              {/* Price */}
              <div className="mb-6 flex items-center gap-4" data-id="element-158">
                <div data-id="element-159">
                  <p className="text-gray-400 line-through text-sm" data-id="element-160">$47.990</p>
                  <p className="font-heading text-5xl font-bold text-gold leading-none" data-id="element-161">
                    $19.990
                  </p>
                </div>
                <div className="bg-red-500 text-white font-bold text-sm rounded-full w-14 h-14 flex items-center justify-center flex-shrink-0" data-id="element-162">
                  -58%
                </div>
              </div>

              {/* CTA */}
              <a href="https://tfjcep-yg.myshopify.com/cart/43485660938318:1" target="_blank" rel="noopener noreferrer" className="block w-full bg-gold text-navy-deep font-bold text-lg py-4 rounded-full hover:bg-gold-light transition-all duration-200 shadow-md hover:shadow-lg transform hover:-translate-y-0.5 mb-3 text-center" aria-label="Adquirir Mega Pack Catequesis Lista por $19.990" data-id="element-163">
                Sí, quiero esta oferta
              </a>
              <p className="text-gray-400 text-xs text-center mb-6" data-id="element-164">
                Pago seguro con Mercado Pago 🔒
              </p>

              {/* Divider */}
              <div className="border-t border-gray-100 pt-6" data-id="element-165">
                <p className="font-bold text-navy-deep uppercase tracking-wider text-sm mb-4" data-id="element-166">
                  INCLUYE:
                </p>
                <ul className="space-y-3" role="list" data-id="element-167">
                  <li className="flex items-start gap-2 text-sm text-gray-700" data-id="element-168">
                    <span className="text-green-500 font-bold mt-0.5 flex-shrink-0" data-id="element-169">
                      ✅
                    </span>
                    <span data-id="element-170">12 Tomos PDF (Primaria + Secundaria)</span>
                  </li>
                  <li className="flex items-start gap-2 text-sm text-gray-700" data-id="element-171">
                    <span className="text-green-500 font-bold mt-0.5 flex-shrink-0" data-id="element-172">
                      ✅
                    </span>
                    <span data-id="element-173">Tomo 1–6: Primaria completa (1° a 6° grado)</span>
                  </li>
                  <li className="flex items-start gap-2 text-sm text-gray-700" data-id="element-174">
                    <span className="text-green-500 font-bold mt-0.5 flex-shrink-0" data-id="element-175">
                      ✅
                    </span>
                    <span data-id="element-176">Tomo 7–12: Secundaria completa (1° a 6° año)</span>
                  </li>
                  <li className="flex items-start gap-2 text-sm text-gray-700" data-id="element-177">
                    <span className="text-green-500 font-bold mt-0.5 flex-shrink-0" data-id="element-178">
                      ✅
                    </span>
                    <span data-id="element-179">Bono Ruta Anual 36 Semanas</span>
                  </li>
                  <li className="flex items-start gap-2 text-sm text-gray-700" data-id="element-180">
                    <span className="text-green-500 font-bold mt-0.5 flex-shrink-0" data-id="element-181">
                      ✅
                    </span>
                    <span data-id="element-182">Bono Guía Comunión y Confirmación</span>
                  </li>
                  <li className="flex items-start gap-2 text-sm text-gray-700" data-id="element-183">
                    <span className="text-green-500 font-bold mt-0.5 flex-shrink-0" data-id="element-184">
                      ✅
                    </span>
                    <span data-id="element-185">Bono Catequesis sin Caos</span>
                  </li>
                  <li className="flex items-start gap-2 text-sm text-gray-700" data-id="element-186">
                    <span className="text-green-500 font-bold mt-0.5 flex-shrink-0" data-id="element-187">
                      ✅
                    </span>
                    <span data-id="element-188">Acceso y descarga de por vida</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Card 2: Mejor Valor */}
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden flex flex-col" style={{
          border: '2px solid #1a2e4a'
        }} data-id="element-189">
            {/* Top Badge */}
            <div className="bg-navy-deep text-gold text-center font-bold uppercase tracking-widest text-sm py-3" data-id="element-190">
              🔥 OFERTA ESPECIAL — PACK COMPLETO
            </div>

            <div className="p-8 flex flex-col flex-1" data-id="element-191">
              {/* Label above */}
              <p className="text-gold text-xs font-bold uppercase tracking-widest mb-2" data-id="element-192">
                MEGA PACK + BONO EXCLUSIVO
              </p>

              {/* Product Name */}
              <h3 className="font-heading text-2xl font-bold text-navy-deep mb-2" data-id="element-193">
                Mega Pack + Adaptación para el Aula Real
              </h3>
              <p className="text-gray-500 text-sm mb-4" data-id="element-194">
                El Mega Pack completo{' '}
                <strong className="text-navy-deep" data-id="element-195">más</strong> el ebook premium{' '}
                <em data-id="element-196">"Pack de Adaptación por Realidades del Aula"</em> — para que
                tus clases funcionen incluso en los contextos más difíciles de
                Argentina.
              </p>

              {/* Problem/Promise callout */}
              <div className="rounded-xl p-4 mb-5 text-sm" style={{
              backgroundColor: 'rgba(201, 168, 76, 0.10)',
              border: '1px solid rgba(201, 168, 76, 0.3)'
            }} data-id="element-197">
                <p className="font-bold text-navy-deep mb-2" data-id="element-198">
                  ¿Tu curso es difícil? Este bono es para vos:
                </p>
                <ul className="space-y-1 text-gray-600" data-id="element-199">
                  <li data-id="element-200">⚡ Cursos heterogéneos o multigrado</li>
                  <li data-id="element-201">⚡ Baja participación o lectoescritura</li>
                  <li data-id="element-202">⚡ Contextos vulnerables</li>
                  <li data-id="element-203">⚡ Semanas cortas por feriados y actos</li>
                </ul>
              </div>

              {/* Price */}
              <div className="mb-6 flex items-center gap-4" data-id="element-204">
                <div data-id="element-205">
                  <p className="text-gray-400 line-through text-sm" data-id="element-206">$69.990</p>
                  <p className="font-heading text-5xl font-bold text-navy-deep leading-none" data-id="element-207">
                    $27.990
                  </p>
                </div>
                <div className="bg-red-500 text-white font-bold text-sm rounded-full w-14 h-14 flex items-center justify-center flex-shrink-0" data-id="element-208">
                  -57%
                </div>
              </div>

              {/* CTA */}
              <a href="https://tfjcep-yg.myshopify.com/cart/43485716578382:1" target="_blank" rel="noopener noreferrer" className="block w-full bg-navy-deep text-white font-bold text-lg py-4 rounded-full hover:bg-navy-dark transition-all duration-200 shadow-md hover:shadow-lg transform hover:-translate-y-0.5 mb-3 text-center" aria-label="Adquirir Mega Pack + Bono Adaptación por $27.990" data-id="element-209">
                Sí, quiero esta oferta
              </a>
              <p className="text-gray-400 text-xs text-center mb-6" data-id="element-210">
                Pago seguro con Mercado Pago 🔒
              </p>

              {/* Divider */}
              <div className="border-t border-gray-100 pt-6" data-id="element-211">
                <p className="font-bold text-navy-deep uppercase tracking-wider text-sm mb-4" data-id="element-212">
                  TODO EL PACK BÁSICO MÁS:
                </p>
                <ul className="space-y-3" role="list" data-id="element-213">
                  <li className="flex items-start gap-2 text-sm text-gray-700" data-id="element-214">
                    <span className="text-green-500 font-bold mt-0.5 flex-shrink-0" data-id="element-215">
                      ✅
                    </span>
                    <span data-id="element-216">
                      <strong data-id="element-217">Estrategias por escenario</strong> — soluciones
                      concretas para cada realidad del aula argentina
                    </span>
                  </li>
                  <li className="flex items-start gap-2 text-sm text-gray-700" data-id="element-218">
                    <span className="text-green-500 font-bold mt-0.5 flex-shrink-0" data-id="element-219">
                      ✅
                    </span>
                    <span data-id="element-220">
                      <strong data-id="element-221">Guiones y frases exactas</strong> para manejar
                      situaciones difíciles sin improvisar
                    </span>
                  </li>
                  <li className="flex items-start gap-2 text-sm text-gray-700" data-id="element-222">
                    <span className="text-green-500 font-bold mt-0.5 flex-shrink-0" data-id="element-223">
                      ✅
                    </span>
                    <span data-id="element-224">
                      <strong data-id="element-225">Estructuras de clase</strong> para 40 y 80 minutos
                      adaptadas al contexto
                    </span>
                  </li>
                  <li className="flex items-start gap-2 text-sm text-gray-700" data-id="element-226">
                    <span className="text-green-500 font-bold mt-0.5 flex-shrink-0" data-id="element-227">
                      ✅
                    </span>
                    <span data-id="element-228">
                      <strong data-id="element-229">Kits de clase corta</strong> de 10 y 20 min para
                      semanas con feriados o actos
                    </span>
                  </li>
                  <li className="flex items-start gap-2 text-sm text-gray-700" data-id="element-230">
                    <span className="text-green-500 font-bold mt-0.5 flex-shrink-0" data-id="element-231">
                      ✅
                    </span>
                    <span data-id="element-232">
                      <strong data-id="element-233">Casos completos ya redactados</strong> — copiá,
                      adaptá y usá directamente
                    </span>
                  </li>
                  <li className="flex items-start gap-2 text-sm text-gray-700" data-id="element-234">
                    <span className="text-green-500 font-bold mt-0.5 flex-shrink-0" data-id="element-235">
                      ✅
                    </span>
                    <span data-id="element-236">
                      100% en PDF — sin links, sin audios, sin conexión a
                      internet
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Below cards */}
        <p className="text-center text-gray-500 text-sm mt-8" data-id="element-237">
          Garantía 7 días &nbsp;•&nbsp; Acceso inmediato
        </p>
      </div>
    </section>;
}